import get from "lodash-es/get";
import { getAssetPath } from "../repository/mms-repository";

type Props = {
	setIsLoadingAssetPath: (isLoading: boolean) => void;
	setErrorAssetPath: (err: string) => void;
	setAssetName: (AssetPath: string) => void;
};

export const useGetAssetPath = ({
	setIsLoadingAssetPath,
	setErrorAssetPath,
	setAssetName,
}: Props) => {
	const GetAssetFullPath = async (assetId: string) => {
		setIsLoadingAssetPath(true);
		const res = await getAssetPath(assetId);
		if (res.ok) {
			const fullPath = get(res, "data.tables[0].rows[0].FullPath", "");
			setAssetName(fullPath);
			setIsLoadingAssetPath(false);
		} else {
			setIsLoadingAssetPath(false);
			setErrorAssetPath(res.message);
		}
	};

	return { GetAssetFullPath };
};
